export const setSupervisedAgentIds = (supervisedAgentIds) => ({
  type: "SET_SUPERVISED_AGENT_IDS",
  payload: supervisedAgentIds,
});

  export const setSupervisedAgentDetails = (supervisedAgentData) => ({
    type: "SET_SUPERVISED_AGENT_DATA",
    payload: supervisedAgentData,
  });